module.exports = __webpack_public_path__ + "images/spi.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/spi.png
// module id = 2130
// module chunks = 0